import React from "react";
import { Box, Container, Grid, Typography, Button, Stack } from "@mui/material";
import {
  Business,
  EmojiEvents,
  PeopleAlt,
  TrendingUp,
} from "@mui/icons-material";
import { ImgBox } from "../../../../Components";
import { useNavigate } from "react-router-dom";

export default function CollaborateSct() {
  const navigate = useNavigate();
  return (
    <Box sx={{ py: "5rem", bgcolor: "custom.contrast" }}>
      <Container maxWidth="xl">
        <Grid container spacing={5} alignItems="center">
          {/* Right side: Info */}
          <Grid sx={{ p: "4px" }} size={{ xs: 12, md: 6 }}>
            <Typography
              variant="overline"
              sx={{ color: "primary.main", fontWeight: 600, letterSpacing: 1 }}
            >
              فرصت همکاری
            </Typography>
            <Typography variant="h6" sx={{ fontWeight: 700, mb: 2, mt: 1 }}>
              باشگاه یا مربی هستید؟
            </Typography>
            <Typography
              variant="body2"
              sx={{ color: "text.secondary", mb: 3, fontSize: "1rem" }}
            >
              ما به شما کمک می‌کنیم تا برند شخصی یا باشگاه خود را به هزاران
              مخاطب هدف معرفی کنید. با بستن قرارداد تبلیغاتی، درآمد پایدار و
              بازاریابی حرفه‌ای را تجربه کنید.
            </Typography>

            <Stack gap={2} sx={{ mb: 4 }}>
              <Stack direction="row" gap={1.5} alignItems="center">
                <EmojiEvents color="primary" />
                <Typography>افزایش اعتبار و دیده‌شدگی برند شما</Typography>
              </Stack>
              <Stack direction="row" gap={1.5} alignItems="center">
                <PeopleAlt color="primary" />
                <Typography>دسترسی به جامعه ورزشی فعال و هدفمند</Typography>
              </Stack>
              <Stack direction="row" gap={1.5} alignItems="center">
                <TrendingUp color="primary" />
                <Typography>
                  درآمد از طریق قراردادهای تبلیغاتی بلندمدت
                </Typography>
              </Stack>
              <Stack direction="row" gap={1.5} alignItems="center">
                <Business color="primary" />
                <Typography>
                  پشتیبانی در تولید محتوا و استراتژی تبلیغات
                </Typography>
              </Stack>
            </Stack>

            <Button
              onClick={() => navigate("/cooperation")}
              variant="contained"
              size="large"
              sx={{
                px: 5,
                py: 1.5,
                borderRadius: 3,
                fontWeight: 600,
                boxShadow: 3,
                "&:hover": { transform: "scale(1.02)", boxShadow: 6 },
                transition: "all 0.2s",
              }}
            >
              ثبت‌درخواست همکاری
            </Button>
          </Grid>

          {/* Left side: Image + CTA card */}
          <Grid sx={{ p: "4px" }} size={{ xs: 12, md: 6 }}>
            <Box sx={{ position: "relative" }}>
              <ImgBox
                component="img"
                src="/media/sample/colab.webp"
                alt="همکاری با مربیان و باشگاه‌ها"
                sx={{
                  width: "100%",
                  overflow: "hidden",
                  borderRadius: "16px",
                  boxShadow: 10,
                  objectFit: "cover",
                  height: { xs: 250, md: 400 },
                }}
              />
              {/* <Box
                sx={{
                  position: "absolute",
                  bottom: 20,
                  left: 20,
                  right: 20,
                  bgcolor: "rgba(0,0,0,0.7)",
                  backdropFilter: "blur(8px)",
                  borderRadius: 3,
                  p: 2,
                  color: "white",
                  textAlign: "center",
                }}
              >
                <Typography variant="h6" fontWeight={600}>
                  اولین قرارداد تبلیغاتی خود را همین حالا ببندید
                </Typography>
              </Box> */}
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}
